<template>
  <div>
    <iframe :src="iframeUrl" style="width:650px;height:300px" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
  import { isEmpty } from '@/utils/fileHelper';

  export default {
    name: 'DocumentVideo',
    props: ['url'],
    data() {
      return {
        isEmpty,
        urlId: '',
        iframeUrl: this.getIframeUrl()
      }
    },
    mounted() {
      this.getIframeUrl()
    },
    methods: {
      getIframeUrl() {
        if (isEmpty(this.url)) {
          this.urlId = this.$route.params.id
        } else {
          this.urlId = this.url
        }
        return `https://www.youtube.com/embed/${this.urlId}?autoplay=0&cc_load_policy=1&modestbranding=1&rel=0`
      }
    }
  }
  </script>
